export default "__VITE_ASSET__B4wegh0t__"